import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styled from 'styled-components';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const ExecutiveLogin = () => {
  const [username, setUsername] = useState('');
  const [passwordHash, setPasswordHash] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const [eyePassword, setEyePassword] = useState(false)

  const [showEyePassword, setShowEyePassword] = useState(false)


  const handleLogin = async (e) => {
    e.preventDefault();

    if (passwordHash.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }

    const payload = {
      userName: username,
      password: passwordHash
    }
    try {
      const response = await axios.post('https://api.bakpoket.com/api/BDExecutive/login', payload);
      localStorage.setItem('excutiveLogin', JSON.stringify(response.data.user));
      alert('Login successful!');
      navigate("/excutive/dashboard")
      // console.log(response.data.user)
      // window.location.reload();
    } catch (error) {
      console.error('Login failed:', error);
      alert('Login failed. Please try again.');
    }
  };


  return (
    <Wrapper className='my-3'>
      <div className="login-main-card">
        <h5>Executive Sign In</h5>

        <form className="auth-form" onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="User Name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <div style={{ position: 'relative' }}>
            <input
              type={showEyePassword ? 'type' : "password"}
              placeholder="Password must contain 8 characters"
              value={passwordHash}
              onChange={(e) => {
                setPasswordHash(e.target.value);
                if (e.target.value.length >= 8) setError('');
              }}
              required
              style={{ width: '100%' }}
            />
            {passwordHash.length > 0 ? (
              eyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(false); setShowEyePassword(false) }} />)
                : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(true); setShowEyePassword(true) }} />)) : (null)
            }
          </div>
          {error && <p className='mb-0' style={{ color: "red", fontSize: "12px" }}>{error}</p>}
          <button type="submit" className="auth-btn">Sign In</button>
        </form>
        <SwitchText>
          <span><NavLink to='/executiveForgotPassword' style={{ textDecoration: 'none', color: '#ef4766' }}>Forgot Password</NavLink></span>
        </SwitchText>
        <SwitchText>
          Don’t have an account? <span><NavLink to='/executiveSignup' style={{ textDecoration: 'none', color: '#ef4766' }}>Sign Up</NavLink></span>
        </SwitchText>
      </div>
    </Wrapper>
  )
}

export default ExecutiveLogin

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  .login-main-card {
    background-color: rgb(233, 231, 231);
    width: 100%;
    max-width: 320px;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .top-text {
    font-weight: bold;
    color: #444;
    margin-bottom: 10px;
  }

  h2 {
    margin-bottom: 25px;
    color: #222;
  }

  .login-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 0px;
  }

  .login-type {
    display: flex;
    justify-content: center;
  }

  .or-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 10px 0;

    span {
      background-color: rgba(71, 70, 70, 0.1);
      padding: 3px;
      color: #666;
      font-weight: 600;
      border-radius: 50%;
    }

    &::before,
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: #999;
    }
  }

  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input {
      padding: 7px;
      border-radius: 6px;
      border: 1px solid #ccc;
      font-size: 13px;
    }
  }

  .auth-btn {
    background-color: #ef4766;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 6px;
    font-weight: bold;
    width: 100%;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background-color: #d91212;
    }
  }
`;

const SwitchText = styled.p`
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 0px;

  span {
    color: #ef4766;
    cursor: pointer;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    font-size: 9px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;
